<template>
<div class="chapter">
<div class="inner_page">
<h1><i>I<br/>
  Drunk With Love</i></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Part01.vue?3b2c4ed2